import axios from "axios";

export const addChallange = async (api, data, token) => {
  try {
    const formData = new FormData();

    formData.append("title", data.title);
    formData.append("club", data.club);
    formData.append("category", data.category);
    formData.append("sub_category", data.subCategory);
    formData.append("from_uk", data.from_uk);
    if (typeof data.videoFile == "object") {
      formData.append("videoFile", data.videoFile);
    }
    formData.append("region", data.region);
    formData.append("user_id", data.user_id);
    formData.append("goal_scorer", data.goal_scorer);
    if (typeof data.club_img == "object") {
      formData.append("club_img", data.club_img);
    }
    formData.append("comments", data.comments);
    formData.append("challenges", true);
    if (api == "editGoal") {
      formData.append("goal_id", data.goal_id);
    }
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/${api}`,
      formData,
      {
        headers: {
          // "Content-Type" : "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response?.data?.message);
    }
    if (error.request) {
    }
    throw new Error(error.message);
  }
};
